import React from 'react';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import WelcomeLayout from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/Welcome/Layout';
import WelcomeBlurb from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeBlurb';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import useDarkHeaderTheme from 'Views/Onboarding/Hooks/useDarkHeaderTheme';
import Typography from 'Components/UI/Typography';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import fr from 'facet-rest';
import WelcomeLowerContentWrapper
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeLowerContent/WelcomeLowerContentWrapper';

const useStyles = (backgroundURL) => buildUseStyles('ModuleWelcomeLayout', (theme) => ({
  root: {},
  image: {
    backgroundImage: `url(${backgroundURL})`,
  },
  text: {
    margin: theme.spacing(2),
  },
  title: {
    fontSize: 32,
    marginTop: theme.spacing(3),
  },
  paper: {
    margin: theme.spacing(2),
    padding: theme.spacing(2, 4),
    backgroundColor: theme.palette.facet.accentBlue,
    borderRadius: 20,
  },
}));

function ModuleWelcomeLayout({
  className,
}) {
  const { onboardingStepResource } = useSurveyContext();
  const imageURL = onboardingStepResource.withRelationship(fr.relationships.image.name, (rel) => rel.link('related').url(), () => '');
  const theme = useTheme();
  const classes = useStyles(imageURL)(theme);

  useScrollTopOnMount();
  useDarkHeaderTheme();

  return (
    <WelcomeLayout
      classes={{
        root: classNames(className, classes.root),
        imageCardContainer: classes.image,
      }}
    >
      <WelcomeLowerContentWrapper>
        <Typography
          className={classes.title}
          variant={'h1'}
          color={'primary'}
          weight={'medium'}
        >
          {onboardingStepResource.attr('header')}
        </Typography>
        <WelcomeParagraphs
          paragraphs={[
            { text: onboardingStepResource.attr('subtitle') },
          ]}
        />
        <WelcomeBlurb
          bullets={onboardingStepResource.attr('informationText').map((text) => ({ text }))}
        />
      </WelcomeLowerContentWrapper>
    </WelcomeLayout>
  );
}

ModuleWelcomeLayout.propTypes = {
  className: PropTypes.string,
};

ModuleWelcomeLayout.defaultProps = {
  className: '',
};

export default ModuleWelcomeLayout;
